import { useCallback } from 'react';
import { Method, useApi } from 'shared/hooks/useApi.ts';

export const useMutation = <TBody = any, TData = any>(): [
  (endpoint: string, body?: TBody, method?: Method) => Promise<any>,
  { error: string | null; loading: boolean; data: TData | null },
] => {
  const { requestApi, error, loading, data } = useApi<TData>(undefined, {
    lazy: true,
  });
  const requestMutation = useCallback(
    (endpoint: string, body?: TBody, method: Method = 'POST') => requestApi(endpoint, body, method),
    [requestApi],
  );

  return [requestMutation, { error, loading, data }];
};
